import type { User } from 'brokertslib/src/dtos'
import { OrganizationLinkPlain } from './OrganizationLink'
import { UserLink } from './UserLink'
import { Link, Text } from '@chakra-ui/react'
import { formatDateTime } from 'brokertslib/src/Utils/formatPrice'

export const UserContractRecapTableRow = ({ user, date }: { user: User, date: Date }) => {
  return (
    <>
      <UserLink userId={user.userId} firstName={user.name} lastName={user.surname} />
      <Text as="span">,&nbsp;</Text>
      <OrganizationLinkPlain id={user.ouId} name={user.ouName} />
      <Text as="span">,&nbsp;</Text>
      {!!user.email &&
                <Link href={`mailto:${user.email}`}>{user.email}</Link>
      }
      <Text as="span">,&nbsp;</Text>
      <Text as="span">
        {formatDateTime(date)}
      </Text>
    </>
  )
}